document.addEventListener("DOMContentLoaded", function () {
  const mobileNavOverlay = document.querySelector('.js-mobile-nav-overlay');
  const collectionGrid = document.querySelector(".collection-grid");
  let filterTogglesLoaded = false;

  function initFilterToggles() {
    const filterToggles = document.querySelectorAll(".js-filter-toggle");
    const filterDrawer = document.querySelector("collection-filters-drawer");

    if (filterToggles.length && filterDrawer) {
      function handleClickOutside(e) {
        if (mobileNavOverlay && mobileNavOverlay.contains(e.target)) {
          toggleFiltersDrawer(false);
        }
      }
  
      function toggleFiltersDrawer(isOpen) {
        filterDrawer.setAttribute("data-active", isOpen.toString());
        if (window.innerWidth > 990) return;
        document.body.setAttribute('data-overlay-active', isOpen.toString());
        if (isOpen) {
          document.addEventListener('click', handleClickOutside);
        } else {
          document.removeEventListener('click', handleClickOutside);
        }
      }
  
      filterToggles.forEach((button, index) => {
        if (filterTogglesLoaded && index === 0) {
          return;
        };
        button.addEventListener('click', (e) => {
          const isOpen = filterDrawer.getAttribute("data-active") === "false";
          toggleFiltersDrawer(isOpen);
          filterToggles.forEach((toggle) => {
            toggle.setAttribute("aria-expanded", isOpen.toString());
          });
        });
        filterTogglesLoaded = true;
      });
    }
  }

  function initFacets() {
    const main = document.querySelector('main');
    const filterContainer = document.querySelector('collection-filters-drawer');
    const gridContainer = document.querySelector('.collection-grid');

    async function fetchAndRenderCollection(url) {
      const sectionUrl = `${url}${url.includes('?') ? '&' : '?'}sections=main-collection`;
  
      try {
        const response = await fetch(sectionUrl);
        const data = await response.json();
  
        const html = new DOMParser().parseFromString(data['main-collection'], 'text/html');
  
        const newFilters = html.querySelector('collection-filters-drawer');
        const newGrid = html.querySelector('.collection-grid');
  
        if (newFilters) filterContainer.innerHTML = newFilters.innerHTML;
        if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;
      } catch (err) {
        console.error('Error fetching collection:', err);
      } finally {
        // Re-initialize filter toggles, price range slider andvariant swatches
        initFilterToggles();
        initPriceRangeSlider();
        window.initCoddleVariantSwatches();
      }
    }

    main.addEventListener('input', handleFilterFormSubmit);
    main.addEventListener('submit', handleFilterFormSubmit);

    async function handleFilterFormSubmit(e) {
      // Check if the event happened inside the filter form
      const form = e.target.closest('#filter-form');
      if (!form) return; // ignore unrelated inputs
  
      e.preventDefault();

      if (e.target.closest('price-range-slider')) {
        return;
      }
  
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${searchParams}`;
  
      gridContainer.style.opacity = '0.5';
      await fetchAndRenderCollection(url);
      gridContainer.style.opacity = '1';
  
      window.history.pushState({}, '', url);
    };
  }

  function initGridToggle() {
    const collectionViewOptions = document.querySelectorAll('.collection-view-option');
    
    if (!collectionViewOptions) return;

    collectionViewOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const optionValue = option.getAttribute("option");

        // Reset opacity for all options
        collectionViewOptions.forEach((opt) => {
          opt.classList.remove('active');
        });

        // Set clicked option's opacity to 1
        option.classList.add('active');

        // Update grid layout
        collectionGrid.setAttribute('data-row-count', `${optionValue}`);
      });
    });
  }

  function initPriceRangeSlider() {

    const dualRange = document.querySelector('.dual-range');
    const minInput = document.querySelector('.min_price');
    const maxInput = document.querySelector('.max_price');
  
    if (!DualRangeSlider || !dualRange) {
      return;
    }
    const rangeSlider = new DualRangeSlider(dualRange);
  
    // Function to update the handle values
    const updateHandles = () => {
      const minPrice = Number(minInput.value) || 500; // Default to 0 if empty
      const maxPrice = Number(maxInput.value) || Number(dualRange.dataset.max); // Use max range if empty
  
      // Set initial handle values
      if (dualRange) {
        dualRange.querySelector('.handle.left').dataset.value = minPrice;
        dualRange.querySelector('.handle.right').dataset.value = maxPrice;
  
        // Update the handles to reflect the initial values
        rangeSlider.updateHandlePosition(minPrice, maxPrice);
      }
    };
  
    // Call updateHandles initially
    updateHandles();
  
    // Set up MutationObserver to watch for changes in the input values
    const observer = new MutationObserver(() => {
      updateHandles();
    });
  
    // Observe the input elements for changes
    observer.observe(minInput, { attributes: true, childList: true, subtree: true });
    observer.observe(maxInput, { attributes: true, childList: true, subtree: true });
  
    // Add event listeners to inputs
    minInput.addEventListener('input', () => {
      rangeSlider.updateHandlesFromInput(minInput.value, 'min');
    });
  
    maxInput.addEventListener('input', () => {
      rangeSlider.updateHandlesFromInput(maxInput.value, 'max');
    });
  };

  if (!collectionGrid) return;

  initFilterToggles();
  initFacets();
  initGridToggle();
  initPriceRangeSlider();
});